import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {PageState} from './qs-checks.reducer';
import {NotificationService} from '@orga-app/providers/notification.service';
import {QsChecksEntityTypes} from '../../../client-constants';
import {Observable} from 'rxjs';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../websocket.actions';
import {filter, map, withLatestFrom} from 'rxjs/operators';
import PRUEFPLAN_ENTITY = QsChecksEntityTypes.PRUEFPLAN_ENTITY;
import PRUEFPLAN_ENTITY_PART_PRUEFOBJEKT = QsChecksEntityTypes.PRUEFPLAN_ENTITY_PART_PRUEFOBJEKT;
import PRUEFPLAN_ENTITY_PART_PRUEFPLAN = QsChecksEntityTypes.PRUEFPLAN_ENTITY_PART_PRUEFPLAN;
import PRUEFPLAN_ENTITY_PART_PRUEFANTWORT = QsChecksEntityTypes.PRUEFPLAN_ENTITY_PART_PRUEFANTWORT;
import PRUEFPLAN_ENTITY_PART_PRUEFCHECKLISTE = QsChecksEntityTypes.PRUEFPLAN_ENTITY_PART_PRUEFCHECKLISTE;
import PRUEFPLAN_ENTITY_PART_PRUEFAUFGABE = QsChecksEntityTypes.PRUEFPLAN_ENTITY_PART_PRUEFAUFGABE;
import PRUEFPLAN_ENTITY_PART_ROLLE_PRUEFER = QsChecksEntityTypes.PRUEFPLAN_ENTITY_PART_ROLLE_PRUEFER;
import PRUEFPLAN_ENTITY_PART_ROLLE_CONTROLLER = QsChecksEntityTypes.PRUEFPLAN_ENTITY_PART_ROLLE_CONTROLLER;
import {GetFunktionsbereichePruefplaeneAdminAction, GetPruefplanAdminAction, GetPruefplanPruefaufgabeAdminAction, GetPruefplanPruefchecklisteAdminAction, GetPruefplanPruefobjektAdminAction} from '../../../client-ngrx/qschecks';
import {PruefAufgabenLadenAction, PruefChecklistenLadenAction, PruefobjekteLadenAction, PruefplanAntwortenLadenAction, QsControllerRollenLadenAction, QsPrueferRollenLadenAction} from './qs-checks.actions.ui';
import {Pruefaufgabe, Pruefcheckliste, Pruefobjekt, Pruefplan} from '../../../clients/qschecks';
import {getPruefAufgabeSelektiert, getPruefChecklisteSelektiert, getPruefobjektSelektiert, getPruefplanSelektiert} from './qs-checks.selectors';

@Injectable()
export class EffectsWs {

    @Effect()
    readModelUpdaterFunktionsbereichePruefplaene$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_PRUEFPLAN;
        })
        , map((x) => {
            return new GetFunktionsbereichePruefplaeneAdminAction();
        })
    );

    @Effect()
    readModelUpdaterFunktionsbereichePruefplaeneDelete$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === ''
                && x.message.method.toUpperCase() === 'DELETE';
        })
        , map((x) => {
            return new GetFunktionsbereichePruefplaeneAdminAction();
        })
    );

    @Effect()
    readModelUpdaterPruefplanAktuell$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_PRUEFPLAN;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefplan> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)))
        , filter(([x, pruefplan]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id;
        })
        , map(([x, pruefplan]) => {
            return new GetPruefplanAdminAction(pruefplan.pruefplan_id);
        })
    );

    @Effect()
    readModelUpdaterPruefplanAntworten$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_PRUEFANTWORT;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefplan> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)))
        , filter(([x, pruefplan]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id;
        })
        , map(([x, pruefplan]) => {
            return new PruefplanAntwortenLadenAction();
        })
    );

    @Effect()
    readModelUpdaterPruefobjekte$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_PRUEFOBJEKT;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefplan> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)))
        , filter(([x, pruefplan]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id;
        })
        , map((x) => {
            return new PruefobjekteLadenAction();
        })
    );

    @Effect()
    readModelUpdaterPruefobjektAktuell$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_PRUEFOBJEKT;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefobjekt> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)),
            this.store.pipe(select(getPruefobjektSelektiert)))
        , filter(([x, pruefplan, pruefobjekt]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id
            && pruefobjekt !== null && pruefobjekt.pruefobjekt_id === x.pruefobjekt_id;
        })
        , map(([x, pruefplan, pruefobjekt]) => {
            return new GetPruefplanPruefobjektAdminAction(x.pruefplan_id, x.pruefobjekt_id);
        })
    );

    @Effect()
    readModelUpdaterPruefChecklisten$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_PRUEFCHECKLISTE;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefplan> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)))
        , filter(([x, pruefplan]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id;
        })
        , map((x) => {
            return new PruefChecklistenLadenAction();
        })
    );

    @Effect()
    readModelUpdaterChecklisteAktuell$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_PRUEFCHECKLISTE;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefcheckliste> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)),
            this.store.pipe(select(getPruefChecklisteSelektiert)))
        , filter(([x, pruefplan, checkliste]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id
                && checkliste !== null && checkliste.pruefcheckliste_id === x.pruefcheckliste_id;
        })
        , map(([x, pruefplan, checkliste]) => {
            return new GetPruefplanPruefchecklisteAdminAction(x.pruefplan_id, x.pruefcheckliste_id);
        })
    );

    @Effect()
    readModelUpdaterPruefAufgaben$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_PRUEFAUFGABE;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefplan> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)))
        , filter(([x, pruefplan]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id;
        })
        , map((x) => {
            return new PruefAufgabenLadenAction();
        })
    );

    @Effect()
    readModelUpdaterAufgabeAktuell$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_PRUEFAUFGABE;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefaufgabe> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)),
            this.store.pipe(select(getPruefAufgabeSelektiert)))
        , filter(([x, pruefplan, aufgabe]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id
                && aufgabe !== null && aufgabe.pruefaufgabe_id === x.pruefaufgabe_id;
        })
        , map(([x, pruefplan, aufgabe]) => {
            return new GetPruefplanPruefaufgabeAdminAction(x.pruefplan_id, x.pruefcheckliste_id, x.pruefaufgabe_id);
        })
    );

    @Effect()
    readModelUpdaterQsPruefer$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_ROLLE_PRUEFER;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefplan> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)))
        , filter(([x, pruefplan]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id;
        })
        , map((x) => {
            return new QsPrueferRollenLadenAction();
        })
    );

    @Effect()
    readModelUpdaterQsController$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFPLAN_ENTITY
                && x.message.entity_part.toUpperCase() === PRUEFPLAN_ENTITY_PART_ROLLE_CONTROLLER;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Pruefplan> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanSelektiert)))
        , filter(([x, pruefplan]) => {
            return pruefplan !== null && x.pruefplan_id === pruefplan.pruefplan_id;
        })
        , map((x) => {
            return new QsControllerRollenLadenAction();
        })
    );

    /*
        @Effect()
        readModelChecklistenDetail$: Observable<Action> = this.actions$.pipe(
            ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
            , filter((x: WsReadModelUpdatedAction) => {
                return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY;
            })
            , withLatestFrom(this.store.pipe(select(getChecklisteDetail)))
            , filter(([x, checkliste]: [WsReadModelUpdatedAction, Checkliste]) => {
                return checkliste !== null && checkliste.checkliste_id !== undefined;
            })
            , map(([x, checkliste]: [WsReadModelUpdatedAction, FunktionsbereichDetail]) => {
                return [<Checkliste> JSON.parse(x.message.entity), checkliste];
            })
            , filter(([x, checkliste]: [Checkliste, Checkliste]) => {
                return x.checkliste_id !== undefined && checkliste.checkliste_id !== undefined && x.checkliste_id === checkliste.checkliste_id;
            })
            , map(([x, checkliste]) => {
                return new GetChecklisteAction(checkliste.checkliste_id);
            })
        );*/

    constructor(private actions$: Actions,
                private store: Store<PageState>,
                private notificationService: NotificationService) {
    }
}
